<template>
  <div>
      <div v-if="!loading" class="uk-section uk-position-relative uk-section-large uk-background-legible uk-background-cover uk-background-fixed uk-background-blend-multiply uk-padding hero page-header" uk-height-viewport="offset-top: true" v-bind:style="{ backgroundImage: `url(${bgImage})`}">
          <!-- <label>PROJECTS / {{project.title}}</label> -->
          <div class="uk-light uk-position-large uk-position-center-left hero-content-left uk-width-2-5@m uk-width-2-3@s uk-width-1-1@xs">

              <router-link :to="project.link" class="text-green"><label>{{project.title}}</label></router-link>
              <h1><b>Meet the Hero:</b> {{project.heroName}}</h1>

              <h3 class="uk-margin-medium-bottom"><em>{{project.quote}}</em></h3>

              <router-link to="storytellers" class="uk-button theme-button button-green" v-if="project.storytellersText">Storytellers</router-link>

          </div>
      </div>

      <div class="uk-section uk-section-medium uk-background-white">
          <div class="uk-container uk-container-small">
              <h1><b>Meet the Hero:</b> {{project.heroName}}</h1>
              <div v-html="project.heroText"></div>
          </div>
      </div>

  </div>
</template>

<script>
export default {
    inject: ['theme'],
    props: ['project'],
    data() {
        return {
        }
    },
    computed: {
        bgImage() {
            if(!!this.project?.heroImage?.large4x3) {
                return this.project.heroImage.large4x3;
            }
            if(!!this.project.image && this.project.image.large4x3) {
                return this.project.image.large4x3;
            }
        }
    }
}
</script>
